import { combineReducers } from 'redux'

import stagedRecord from './stagedRecord'
import uiFlags from './uiFlags'

export default combineReducers({
  uiFlags,
  stagedRecord,
})
